// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"f54ce610793093f2b6c5","293":"faaf38f4c45973600615","518":"ca22f81c3d1f50f13eda","779":"5ca1fd25f24481205579"}[chunkId] + ".js";
};